import { useState, useEffect } from "react";
import { getPopupNoticeList, PopupNoticeData } from "../../../../api/notice";

const usePopupNotice = () => {
  const [popupNoticeData, setPopupNoticeData] = useState<PopupNoticeData[]>([]);

  const loadPopupNotices = async () => {
    try {
      const res = await getPopupNoticeList();
      const filteredData = res.filter((x) => {
        // localStorage.setItem(`popup_notice_${data.id}`, new Date().toISOString());
        // 위 코드는 오늘하루 보지 않기 처리
        // 오늘 하루 보지않기 처리된것들 제외
        const prevData = localStorage.getItem(`popup_notice_${x.id}`);
        if (!prevData) {
          return true;
        } else {
          const prevDate = new Date(prevData);
          const now = new Date();
          return now.getDate() !== prevDate.getDate();
        }
      });
      setPopupNoticeData(filteredData);
    } catch (error) {
      console.error("팝업 공지사항 로드 실패:", error);
    }
  };

  const dismissPopupNotice = (noticeId: number | string) => {
    localStorage.setItem(`popup_notice_${noticeId}`, new Date().toISOString());
    setPopupNoticeData((prev) =>
      prev.filter((notice) => notice.id !== noticeId)
    );
  };

  useEffect(() => {
    loadPopupNotices();
  }, []);

  return {
    popupNoticeData,
    loadPopupNotices,
    dismissPopupNotice,
    setPopupNoticeData,
  };
};

export default usePopupNotice;
